import '@babel/polyfill';
import $ from 'jquery';
import config from '../store/_config';
import {
    axiosInstance as axios,
    handleAxiosErrors,
    isInGodMode,
} from '../_utils';
import {
    convertDataToListingDisplay,
    convertProductSalePricesToAReadableFormat,
    convertProductsListingToAReadableFormat,
    convertUserDetailedInformationToAReadableFormat,
    getProductsListingMaleButtonIDs,
    getProductsListingMatchingManagementTagIDs,
    getProductsListingRelatedProductIDs,
    getProductsListingRelatedTagIDs,
} from '../selectors/converterSelector';
import {
    axiosRequestProductsByIDs,
    axiosRequestSellPriceByBuyableIDs,
    axiosRequestProductsByCodeTagFamily,
} from './productActions';
import { axiosRequestPICNumbers } from './picNumberActions';
import {
    addToCart,
    axiosUpdateCart,
    axiosUpdateCartItemCustomTag,
    getCartData,
    requestCart,
} from './cartActions';
import {
    calculateNearestCartQty,
    generateMMTProcessedLayoutKey,
    generateProcessedLayoutKey,
    getAdditionalProductsForCustomTag,
    getAvailablePrintingMethods,
    getAvailableProcessedLayouts,
    getAvailableTagProductionTypes,
    getAvailableTagUsage,
    getFinalisedTagTypeLayout,
    getMarkingCode,
    getPrintOptionValue,
    getRelatedProducts,
    getRelatedTags,
    getSelectedMaleButtonProducts,
    getSelectedMMT,
    getSelectedMMTF,
    getSelectedOfficialTagLayoutData,
    getSelectedProduct,
    getTagOfficialType,
    getPayloadForOfficalTagCartItem,
    getPossibleVariationTypesForNAIT,
    getIgnoreAbleLineItemIndices,
} from '../selectors/tagWizardSelector';
import { displayRecommendedProducts } from '../dom/cart';
import {
    cancelLayer,
    saveLayer,
    changeFontColour,
    resetTagData,
    toggleEditorLoading,
    getExportedJSONData as getEditorExportedJSONData,
    exportJSON,
    setTagData,
    setBaseTagData,
    exportSVGs,
} from './editorActions';
import { axiosReadTagCart } from './cartTagActions';
import { exportedkeys } from '../reducers/TagWizardReducer';
import { ActionCreators } from 'redux-undo';
import { createAlert, scrollTo } from '../dom/window';
import { resetCanvases, setupCanvases } from './canvasActions';
import { getTranslation } from '../lang/main';
import { buildRequestProductsParams } from '../selectors/productSelector';
import { getTagData } from '../selectors/defaultSelectors';
import { axiosReOrderCartUpdate, axiosReOrderSettings } from './orderActions';
import Axios from 'axios';
import { string } from 'prop-types';
export const scrollToTop = () => {
    scrollTo($('body'));
};
export const toggleLoading = (value) => {
    return {
        type: 'TOGGLE_TAG_WIZARD_LOADING',
        value: value,
    };
};
export const setTagWizardData = (data) => {
    return (dispatch, getState) => {
        dispatch(ActionCreators.clearHistory());
        dispatch({
            type: 'TAG_WIZARD_SET_DATA',
            data: data,
        });
    };
};
export const setTagWizardError = (key, value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'TAG_WIZARD_SET_ERROR',
            key: key,
            value: value,
        });
    };
};
export const setTagWizardAvailableLayouts = (key, list) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'TAG_WIZARD_SET_AVAILABLE_LAYOUTS',
            key: key,
            list: list,
        });
    };
};
export const setMMTTagLayout = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'TAG_WIZARD_SET_MMT_LAYOUT',
            value: value,
        });
    };
};
export const setMMTFTagLayout = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'TAG_WIZARD_SET_MMTF_LAYOUT',
            value: value,
        });
    };
};

export const resetTagWizard = () => {
    return (dispatch, getState) => {
        const tagWizardState = getState().tagWizard.present;
        const selectedProduct = getSelectedProduct(tagWizardState);

        dispatch({
            type: 'TAG_WIZARD_RESET',
        });

        dispatch(setDefaultTagUsage());
        dispatch(setDefaultPrintingMethods());
        dispatch(setDefaultTagProductionTypes());

        if (selectedProduct) {
            const { MinOrderQuantity } = selectedProduct;
            dispatch(setUserInput('cartQty', MinOrderQuantity));
        }
    };
};
export const initializeScreenHistory = () => {
    return (dispatch, getState) => {
        window.onpopstate = function (event) {
            // console.log(event);
            //
            // const {state} = event;
            //
            // if (typeof(state) != 'undefined' && typeof(state.apptype) != 'undefined' && state.apptype == 'tagwizard') {
            //     dispatch(changeScreen(state.screen, true));
            // }
            // else {
            //     dispatch(changeScreen('UsageScreen', true));
            // }

            const pastStates = getState().tagWizard.past;
            const pastState = pastStates[pastStates.length - 1];

            if (typeof pastState != 'undefined') {
                dispatch(changeScreen(pastState.currentScreen, true));
            }
        };
    };
};
export const changeScreen = (
    value,
    ignoreHistoryTracking,
    disableOnAfterChange = false
) => {
    return (dispatch, getState) => {
        if (
            !(
                typeof ignoreHistoryTracking != 'undefined' &&
                ignoreHistoryTracking
            )
        ) {
            window.history.pushState(
                { apptype: 'tagwizard', screen: value },
                document.title,
                document.location
            );
        }

        const currentScreen = getState().tagWizard.present.currentScreen;

        return Promise.all([
            dispatch(
                onBeforeChangeScreen(value, currentScreen, disableOnAfterChange)
            ),
        ])
            .then((response) => {
                if (!response[0].status) {
                    throw new Error('Status is false');
                }

                dispatch({
                    type: 'TAG_WIZARD_CHANGE_SCREEN',
                    value: value,
                });
            })
            .then(() => {
                scrollTo($('#tag-wizard'), 10);

                if (value === 'UsageScreen') {
                    toggleOtherInformation(true);
                } else {
                    toggleOtherInformation(false);
                }

                dispatch(
                    onAfterChangeScreen(
                        value,
                        currentScreen,
                        disableOnAfterChange
                    )
                );
            })
            .catch((error) => {
                console.log(error);
            });
    };
};

export const cancelLayerChangeScreen = (id, targetScreen) => {
    return (dispatch) => {
        Promise.all([
            dispatch(cancelLayer(id)),
            dispatch(changeScreen(targetScreen, false, true)),
        ]);
    };
};

export const saveLayerChangeScreen = (id, targetScreen) => {
    return (dispatch) => {
        Promise.all([
            dispatch(saveLayer(id)),
            dispatch(changeScreen(targetScreen, false, true)),
        ]);
    };
};

export const nextScreen = (steps, currentScreen) => {
    return (dispatch, getState) => {
        let store = getState();
        let nextScreen = '';
        const tagWizardState = store.tagWizard.present;
        if (tagWizardState.userInput.LazyLetter === '3') {
            dispatch(setUserInput('Character2', ''));
        }

        steps.forEach((step, key) => {
            if (step.screen == currentScreen) {
                if (typeof steps[key + 1] != 'undefined') {
                    nextScreen = steps[key + 1].screen;
                }
            }
        });

        if (nextScreen) {
            dispatch(changeScreen(nextScreen));
        } else {
            console.error(
                'Could not find next screen',
                steps,
                currentScreen,
                nextScreen
            );
        }
    };
};

/**
 * Helper function that triggers before the screen is changed to the next screen
 *
 * @param nextScreen
 * @param disableOnBeforeChange
 * @returns {function(*, *): *}
 */
export const onBeforeChangeScreen = (
    nextScreen,
    currentScreen,
    disableOnBeforeChange = false
) => {
    return (dispatch, getState) => {
        if (disableOnBeforeChange !== true) {
            switch (nextScreen) {
                case 'NlisAppearanceScreen':
                    if (
                        currentScreen == 'NLISPropertyScreen' ||
                        currentScreen == 'ReviewScreen' ||
                        currentScreen == 'UsageScreen'
                    ) {
                        return Promise.all([
                            dispatch(requestProcessedLayouts('nlis')),
                        ]).then(() => {
                            const availableProcessedLayouts = getAvailableProcessedLayouts(
                                getState().tagWizard.present
                            );

                            return {
                                status: availableProcessedLayouts.length,
                            };
                        });
                    }
                    break;

                case 'NAITAppearanceScreen':
                    if (
                        currentScreen == 'NAITPropertyScreen' ||
                        currentScreen == 'ReviewScreen'
                    ) {
                        return Promise.all([
                            dispatch(requestProcessedLayouts('nait')),
                        ]).then(() => {
                            const availableProcessedLayouts = getAvailableProcessedLayouts(
                                getState().tagWizard.present
                            );

                            return {
                                status: availableProcessedLayouts.length,
                            };
                        });
                    }
                    break;

                case 'ReviewScreen':
                    if (currentScreen == 'NlisAppearanceScreen') {
                        console.log('Requesting on NlisAppearanceScreen');
                        return Promise.all([
                            dispatch(requestMMTProcessedLayouts()),
                        ]).then(() => {
                            return {
                                status: true,
                            };
                        });
                    }

                    if (currentScreen == 'NAITAppearanceScreen') {
                        console.log('Requesting on NAITAppearanceScreen');
                        return Promise.all([
                            dispatch(validateNAITSequence()),
                        ]).then((response) => {
                            if (response[0].status !== true) {
                                dispatch(
                                    changeScreen(
                                        'NAITPropertyScreen',
                                        true,
                                        true
                                    )
                                );

                                return response[0];
                            } else {
                                return Promise.all([
                                    dispatch(requestMMTProcessedLayouts()),
                                    dispatch(requestMMTFProcessedLayouts()),
                                ])
                                    .then(() => {
                                        return dispatch(
                                            requestIncludedProductsOfNAITMMT()
                                        );
                                    })
                                    .then(() => {
                                        return {
                                            status: true,
                                        };
                                    });
                            }
                        });
                    }
                    break;
            }
        }

        return {
            status: true,
        };
    };
};

/**
 * Request Included Products on NAIT MMT
 * @returns {Function}
 */
export const requestIncludedProductsOfNAITMMT = () => {
    return (dispatch, getState) => {
        const tagWizardState = getState().tagWizard.present;
        const { selectedMMTTagLayout, selectedMMTFTagLayout } = tagWizardState;

        let lineItemIDs = [];

        if (
            selectedMMTTagLayout &&
            selectedMMTTagLayout.IncludedProducts &&
            selectedMMTTagLayout.IncludedProducts.length
        ) {
            lineItemIDs = [
                ...lineItemIDs,
                ...selectedMMTTagLayout.IncludedProducts.map((item) =>
                    Number(item.ID)
                ),
            ];
        }

        if (
            selectedMMTFTagLayout &&
            selectedMMTFTagLayout.IncludedProducts &&
            selectedMMTFTagLayout.IncludedProducts.length
        ) {
            lineItemIDs = [
                ...lineItemIDs,
                ...selectedMMTFTagLayout.IncludedProducts.map((item) =>
                    Number(item.ID)
                ),
            ];
        }

        if (lineItemIDs.length > 0) {
            return Promise.all([
                dispatch(requestLineItemProducts(lineItemIDs)),
            ]);
        }
    };
};

/**
 * Helper function that triggers after the screen is changed to the next screen
 *
 * @param nextScreen
 * @param disableOnBeforeChange
 * @returns {function(*, *): *}
 */
export const onAfterChangeScreen = (
    nextScreen,
    currentScreen,
    disableOnAfterChange = false
) => {
    return (dispatch, getState) => {
        if (disableOnAfterChange !== true) {
            switch (nextScreen) {
                case 'SideMenuScreen':
                    window.dispatchEvent(new Event('resize'));
                    break;
            }
        }

        return;
    };
};

export const toggleOtherInformation = (visible) => {
    const $relatedProductSection = $('#related-products-section');
    const $returnToParent = $('.product-return-to-parent');

    if (visible) {
        if ($relatedProductSection.length) {
            $relatedProductSection.removeAttr('style');
        }
        if ($returnToParent.length) {
            $returnToParent.removeAttr('style');
        }
    } else {
        if ($relatedProductSection.length) {
            $relatedProductSection.css({
                position: 'absolute',
                opacity: 0,
                pointerEvents: 'none',
                display: 'none',
            });
        }
        if ($returnToParent.length) {
            $returnToParent.css({
                position: 'absolute',
                opacity: 0,
                pointerEvents: 'none',
                display: 'none',
            });
        }
    }
};

export const updateHasInitialized = (value) => {
    return {
        type: 'UPDATE_PRODUCT_VARIATION_LIST_HAS_INITIALIZED',
        value: value,
    };
};
export const setPICValidationStatus = (value) => {
    return {
        type: 'TAG_WIZARD_SET_PIC_VALIDATION',
        value: value,
    };
};
export const setPropertyValidationStatus = (value) => {
    return {
        type: 'TAG_WIZARD_SET_PROPERTY_VALIDATION',
        value: value,
    };
};
export const setPropertyValidationState = (value) => {
    return {
        type: 'TAG_WIZARD_SET_PROPERTY_STATE',
        value: value,
    };
};
export const setLastSequenceNumber = (value) => {
    return {
        type: 'TAG_WIZARD_SET_LAST_SEQUENCE_NUMBER',
        value: value,
    };
};
export const updateCartQty = (value, forceUpdate = true) => {
    return (dispatch, getState) => {
        const tagWizardState = getState().tagWizard.present;
        const selectedProduct = getSelectedProduct(tagWizardState);

        if (selectedProduct) {
            const { SellByPackageOnly, MinOrderQuantity } = selectedProduct;
            const packSize = MinOrderQuantity;

            const finalCartQty = forceUpdate
                ? calculateNearestCartQty(
                    SellByPackageOnly,
                    value,
                    packSize,
                    MinOrderQuantity
                )
                : value;

            dispatch(setUserInput('cartQty', finalCartQty));
        }
    };
};
export const setSelectedProduct = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'TAG_WIZARD_SELECT_PRODUCT',
            value: value,
        });

        const state = getState().tagWizard.present;
        const currentCartQty = state.userInput.cartQty;
        const selectedProduct = getSelectedProduct(state);

        dispatch(
            changeFontColour(
                selectedProduct.TagColour,
                selectedProduct.FontColourCode
            )
        );

        if (
            typeof currentCartQty === 'undefined' ||
            selectedProduct.MinOrderQuantity > currentCartQty
        ) {
            dispatch(updateCartQty(selectedProduct.MinOrderQuantity));
        } else if (currentCartQty <= 1) {
            dispatch(updateCartQty(1));
        }
    };
};
export const setSelectedMatchingManagementTag = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'TAG_WIZARD_SELECT_MATCHING_MANAGEMENT_TAG',
            value: value,
        });
    };
};
export const setSelectedMatchingManagementFemaleTag = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'TAG_WIZARD_SELECT_MATCHING_MANAGEMENT_FEMALE_TAG',
            value: value,
        });
    };
};
export const setSelectedIncludedItem = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'TAG_WIZARD_SELECT_INCLUDED_ITEM_TAG',
            value: value,
        });
    };
};
export const setSelectedMaleButton = (key, value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'TAG_WIZARD_SELECT_MALE_BUTTON',
            key: key,
            value: value,
        });
    };
};
export const setSelectedAddons = (list) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'TAG_WIZARD_SET_PRODUCT_ADDON',
            list: list,
        });
    };
};
export const updateSelectedAddons = (list) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'TAG_WIZARD_UPDATE_PRODUCT_ADDON',
            list: list,
        });
    };
};
export const updateLineItemsProductList = (value) => {
    return {
        type: 'TAG_WIZARD_UPDATE_LINE_ITEMS_PRODUCTS',
        list: value,
    };
};
export const updateProductList = (value) => {
    return {
        type: 'TAG_WIZARD_UPDATE_PRODUCTS',
        list: value,
    };
};
export const setProductList = (value) => {
    return {
        type: 'TAG_WIZARD_SET_PRODUCTS',
        list: value,
    };
};
export const updatePICNumberList = (value) => {
    return {
        type: 'TAG_WIZARD_UPDATE_PIC_NUMBERS',
        list: value,
    };
};
export const setUserInput = (key, value) => {
    return (dispatch, getState) => {
        const tagWizardState = getState().tagWizard.present;
        const {
            tagType,
            printingMethod,
            tagProductionType,
        } = tagWizardState.userInput;

        dispatch({
            type: 'TAG_WIZARD_SET_USER_INPUT',
            key: key,
            value: value,
        });

        let resetCanvas = false;

        if (key == 'tagType') {
            if (tagType != value) {
                if (value !== 'blank') {
                    resetCanvas = true;
                }

                if (value === 'nlis' && !tagProductionType) {
                    dispatch(setDefaultTagProductionTypes());
                }
            }
        }

        if (key == 'printingMethod') {
            if (printingMethod != value) {
                resetCanvas = true;
            }
        }

        if (key == 'cartQty') {
            dispatch(onAfterCartQtyChangeNAIT());
        }

        if (resetCanvas === true) {
            Promise.all([
                dispatch(resetCanvases()),
                dispatch(resetTagData(value)),
            ]).then(() => {
                dispatch(setupCanvases());
            });
        }
    };
};
export const updatedMatchingManagementTags = (value) => {
    return {
        type: 'TAG_WIZARD_UPDATE_MATCHING_MANAGEMENT_TAG_LIST',
        value: value,
    };
};
export const updatedMaleButtonTags = (value) => {
    return {
        type: 'TAG_WIZARD_UPDATE_MALE_BUTTON_TAG_LIST',
        value: value,
    };
};
export const updatedRelatedTags = (value) => {
    return {
        type: 'TAG_WIZARD_UPDATE_RELATED_TAG_LIST',
        value: value,
    };
};
export const updateRelatedProducts = (value) => {
    return {
        type: 'TAG_WIZARD_UPDATE_RELATED_PRODUCT_LIST',
        value: value,
    };
};

export const updatedIncludedItemTags = (value) => {
    return {
        type: 'TAG_WIZARD_UPDATE_INCLUDED_ITEM_TAG_LIST',
        value: value,
    };
};

export const requestPICNumbers = (orderOnBehalf = false) => {
    return (dispatch, getState) => {
        return axiosRequestPICNumbers(0, orderOnBehalf)
            .then((response) => {
                const userInfo = convertUserDetailedInformationToAReadableFormat(
                    response.data.data.readOneMember
                );
                let picNumbers = {};

                if (userInfo.availablePICNumbers) {
                    userInfo.availablePICNumbers.forEach(
                        (item) => (picNumbers[item.ID] = item)
                    );
                }

                dispatch(updatePICNumberList(picNumbers));
            })
            .catch((error) => {
                handleAxiosErrors(error);
            });
    };
};
export const requestAllProducts = () => {
    return (dispatch, getState) => {
        const familyTitleSlug =
            typeof window.familyTitleSlug != 'undefined'
                ? window.familyTitleSlug
                : '';

        if (!familyTitleSlug) {
            console.error(
                'Error: No family title slug given, aborting request'
            );
            return;
        }

        const params = {
            filters: {
                FamilyTitleSlug: familyTitleSlug,
            },
        };

        dispatch(toggleLoading(true));

        return axiosRequestProductsForTag(params)
            .then((response) => {
                const list = convertProductsListingToAReadableFormat(
                    response.data.data.readProducts
                );
                const listingDisplay = convertDataToListingDisplay(
                    response.data.data.readProducts,
                    'ID'
                );
                const relatedTagIDs = getProductsListingRelatedTagIDs(
                    response.data.data.readProducts
                );
                const matchingManagementTagProductIDs = getProductsListingMatchingManagementTagIDs(
                    list
                );
                const maleButtonProductIDs = getProductsListingMaleButtonIDs(
                    response.data.data.readProducts
                );

                let relatedProductIDs;
                let additionalRequests = [];

                dispatch(updateProductList(list));
                if (listingDisplay && listingDisplay.length) {
                    additionalRequests.push(
                        dispatch(requestPrice(listingDisplay))
                    );
                }

                if (typeof window.currentProductID !== 'undefined') {
                    dispatch(setSelectedProduct(window.currentProductID));
                    relatedProductIDs = getProductsListingRelatedProductIDs(
                        response.data.data.readProducts
                    );
                } else if (listingDisplay.length > 0) {
                    dispatch(setSelectedProduct(listingDisplay[0]));
                }

                if (matchingManagementTagProductIDs.length > 0) {
                    console.log(
                        '>> Requesting Matching Management Tags with IDs: ',
                        matchingManagementTagProductIDs
                    );
                    additionalRequests.push(
                        dispatch(
                            requestMatchingManagementTags(
                                matchingManagementTagProductIDs
                            )
                        )
                    );
                }

                if (relatedTagIDs.length > 0) {
                    console.log(
                        '>> Requesting Related Tag with IDs: ',
                        relatedTagIDs
                    );
                    additionalRequests.push(
                        dispatch(requestRelatedTags(relatedTagIDs))
                    );
                }

                if (relatedProductIDs.length > 0) {
                    console.log(
                        '>> Requesting Related Product with IDs: ',
                        relatedProductIDs
                    );
                    additionalRequests.push(
                        dispatch(requestRelatedProducts(relatedProductIDs))
                    );
                }

                if (maleButtonProductIDs.length > 0) {
                    console.log(
                        '>> Requesting Male Button with IDs: ',
                        maleButtonProductIDs
                    );
                    additionalRequests.push(
                        dispatch(requestMaleButtonTags(maleButtonProductIDs))
                    );
                }

                dispatch(setDefaultPrintingMethods());
                dispatch(setDefaultTagProductionTypes());

                return Promise.all(additionalRequests);
            })
            .catch((error) => {
                handleAxiosErrors(error);
            })
            .finally(() => {
                dispatch(toggleLoading(false));
            });
    };
};
/**
 * Request price for the given buyable IDs
 *
 * @param buyableIDs
 * @returns {Function}
 */
export const requestPrice = (buyableIDs) => {
    return (dispatch, getState) => {
        return axiosRequestSellPriceByBuyableIDs(buyableIDs).then(
            (response) => {
                const prices = convertProductSalePricesToAReadableFormat(
                    response.data.data.readBuyablePrices
                );

                dispatch(updateProductList(prices));
            }
        );
    };
};
/**
 * Read cart item that holds all the tag data (editor & tagWizard) state
 *
 * @returns {function(*, *): *}
 */
export const readTagCart = () => {
    return (dispatch, getState) => {
        if (!window.cartItemID) return;

        return axiosReadTagCart(window.cartItemID)
            .then(async (response) => {
                const cartData = response.data.data.readOneCartOrderItem;

                if (cartData) {
                    await dispatch(resetCanvases());
                    await dispatch(
                        setTagData(JSON.parse(window.decodeJsonFromBase64(cartData.TagEditorData)))
                    );
                    await dispatch(setupCanvases());

                    // Store the tag wizard state last because we want to make sure tag editor is rendering first.
                    await dispatch(
                        restoreTagWizardState(
                            JSON.parse(window.decodeJsonFromBase64(cartData.TagWizardData))
                        )
                    );
                } else {
                    createAlert(
                        {
                            message: 'Invalid Tag Data from Cart',
                        },
                        'error'
                    );
                }
            })
            .catch((response) => {
                handleAxiosErrors(response);
            });
    };
};
/**
 * Add Blank Tag to cart
 *
 * @param payload
 * @returns {Function}
 */
export const addToCartBlank = (payload) => {
    return (dispatch, getState) => {
        const state = getState();
        const tagWizardState = state.tagWizard.present;
        const relatedProducts = getRelatedProducts(state.tagWizard.present);
        const showRecommendedProducts = relatedProducts.length > 0;

        const selectedMaleButtonProducts = getSelectedMaleButtonProducts(
            tagWizardState
        ).map((product) => {
            return {
                BuyableID: product.ID,
                TotalUnitItems: product.quantity,
            };
        });

        const relatedBuyables = selectedMaleButtonProducts;

        dispatch(toggleLoading(true));

        const callback = {
            success: () => {
                if (showRecommendedProducts) {
                    displayRecommendedProducts();
                }

                dispatch(resetTagWizard());

                scrollToTop();
            },
        };

        Promise.all([
            dispatch(
                addToCart(
                    {
                        ...payload,
                        RelatedBuyables: window.encodeJsonToBase64(JSON.stringify(relatedBuyables)),
                        IsCustomTag: false,
                    },
                    callback,
                    !showRecommendedProducts
                )
            ),
        ]).then(() => {
            dispatch(toggleLoading(false));
        });
    };
};
/**
 * Add Tag Editor Tag item to cart
 *
 * @param passedPayload
 * @returns {Function}
 */
export const addToCartTagEditor = (passedPayload) => {
    return (dispatch, getState) => {
        console.log('PassPayload ========================>', passedPayload);

        const state = getState();
        const editorState = state.editor.present;
        const tagWizardState = state.tagWizard.present;
        const tagData = getTagData(editorState, tagWizardState);
        const relatedProducts = getRelatedProducts(tagWizardState);
        const showRecommendedProducts = relatedProducts.length > 0;
        const ignoreAbleLineItemIndices = getIgnoreAbleLineItemIndices(
            passedPayload.TagSummaryData
        );

        const additionalProductsForCustomTag = getAdditionalProductsForCustomTag(
            state
        ).filter((item, key) => {
            return ignoreAbleLineItemIndices[key] == undefined;
        });

        console.log(
            'additionalProductsForCustomTag ===========>',
            additionalProductsForCustomTag
        );
        console.log('IgnoreAbleLineItems', ignoreAbleLineItemIndices);

        const selectedMaleButtonProducts = getSelectedMaleButtonProducts(
            tagWizardState
        );

        const relatedBuyables = [
            ...additionalProductsForCustomTag,
            ...selectedMaleButtonProducts,
        ].map((product) => {
            return {
                BuyableID: product.ID,
                TotalUnitItems: product.quantity,
            };
        });

        console.log(
            'id-----------------------',
            window.encodeJsonToBase64(JSON.stringify(relatedBuyables))
        );

        const markingCode = getMarkingCode(state);
        const svgs = exportSVGs(editorState);

        const payload = {
            ...passedPayload,
            IsCustomTag: true,
            TagWizardData: window.encodeJsonToBase64(
                JSON.stringify(getTagWizardExportedJSONData(tagWizardState))
            ),
            TagEditorData: window.encodeJsonToBase64(
                JSON.stringify(getEditorExportedJSONData(state))
            ),
            RelatedBuyables: window.encodeJsonToBase64(JSON.stringify(relatedBuyables)),
            SVGPreviewFront:
                typeof svgs.front != 'undefined' ? window.encodeJsonToBase64(svgs.front) : '',
            SVGPreviewBack:
                typeof svgs.back != 'undefined' ? window.encodeJsonToBase64(svgs.back) : '',
            MarkingCodeFront: markingCode.front,
            MarkingCodeBack: markingCode.back,
            PrintOption: getPrintOptionValue(tagData),
        };
        console.log('==============payload', payload);

        dispatch(toggleEditorLoading(true));
        dispatch(toggleLoading(true));

        const callback = {
            success: () => {
                if (showRecommendedProducts) {
                    displayRecommendedProducts();
                }

                // Move to UsageScreen
                dispatch(changeScreen('UsageScreen'));

                // Reset tag wizard
                dispatch(resetTagWizard());

                // And scroll to top
                setTimeout(() => {
                    scrollToTop();
                }, 500);
            },
        };

        Promise.all([
            dispatch(
                addToCart(payload, callback, !showRecommendedProducts, 'editor')
            ),
        ]).then(() => {
            dispatch(toggleEditorLoading(false));
            dispatch(toggleLoading(false));
        });
    };
};

/**
 * ReOrder Tag Editor Tag item to cart
 *
 * @param passedPayload
 * @returns {Function}
 */
export const reOrderTagEditor = (id) => {
    return (dispatch, getState) => {
        const state = getState();
        const memberID = state?.user?.info?.basicInfo?.ID;
        axiosReOrderSettings(id)
            .then((response) => {
                if (
                    window.CurrentMember !==
                    response.data.data.readOneCartOrder.Member.ID &&
                    window.memberType != 'Customer'
                ) {
                    var bodyFormData = new FormData();
                    bodyFormData.append(
                        'MemberID',
                        response.data.data.readOneCartOrder.Member.ID
                    );
                    Axios({
                        method: 'post',
                        url: `${window.baseURL}api/enterprise/orderOnBehalf`,
                        data: bodyFormData,
                        headers: { 'Content-Type': 'multipart/form-data' },
                    })
                        .then(function (res) {
                            const reOrderCartData = getCartData(
                                response.data.data.readOneCartOrder
                            );
                            axiosReOrderCartUpdate(reOrderCartData).then(
                                (response) => {
                                    const allResponses = [response];
                                    window.location.reload();
                                }
                            ).catch((error) => {
                                console.log(error);
                                handleAxiosErrors(error);
                                bodyFormData.set('MemberID', 0);
                                Axios({
                                    method: 'post',
                                    url: `${window.baseURL}api/enterprise/orderOnBehalf`,
                                    data: bodyFormData,
                                    headers: { 'Content-Type': 'multipart/form-data' },
                                })
                                    .then(function (res) {
                                        console.log("Could not place order")
                                        window.location.reload();
                                    })
                            });
                        })
                        .catch(function (response) {
                            console.log(response);
                        });
                } else {
                    const reOrderCartData = getCartData(
                        response.data.data.readOneCartOrder
                    );
                    const message = 'REORDER items have been added to cart';
                    createAlert(
                        {
                            message,
                        },
                        'success'
                    );
                    // axiosReOrderCartUpdate
                    axiosReOrderCartUpdate(reOrderCartData)
                        .then((response) => {
                            const allResponses = [response];
                            window.location.reload();
                        })
                        .catch((error) => {
                            handleAxiosErrors(error);
                        })
                        .then(() => {
                            // toggleOrderLoading(false);
                        });
                }
            })
            .catch((error) => {
                handleAxiosErrors(error);
            })
            .then(() => {
                // toggleOrderLoading(false);
            });
    };
};

/**
 * Update Tag Editor Tag item to cart
 *
 * @param passedPayload
 * @returns {Function}
 */
export const updateCartOrderItemTagEditor = (passedPayload) => {
    return (dispatch, getState) => {
        const state = getState();
        const editorState = state.editor.present;
        const tagWizardState = state.tagWizard.present;
        const tagData = getTagData(editorState, tagWizardState);
        const relatedProducts = getRelatedProducts(tagWizardState);
        const showRecommendedProducts = relatedProducts.length > 0;

        const ignoreAbleLineItemIndices = getIgnoreAbleLineItemIndices(
            passedPayload.TagSummaryData
        );

        const additionalProductsForCustomTag = getAdditionalProductsForCustomTag(
            state
        ).filter((item, key) => {
            return ignoreAbleLineItemIndices[key] == undefined;
        });
        const selectedMaleButtonProducts = getSelectedMaleButtonProducts(
            tagWizardState
        );



        const relatedBuyables = [
            ...additionalProductsForCustomTag,
            ...selectedMaleButtonProducts,
        ].map((product) => {
            return {
                BuyableID: product.ID,
                TotalUnitItems: product.quantity,
            };
        });

        const markingCode = getMarkingCode(state);
        const svgs = exportSVGs(editorState);

        const payload = {
            ...passedPayload,
            IsCustomTag: true,
            TagWizardData: window.encodeJsonToBase64(
                JSON.stringify(getTagWizardExportedJSONData(tagWizardState))
            ),
            TagEditorData: window.encodeJsonToBase64(
                JSON.stringify(getEditorExportedJSONData(state))
            ),
            RelatedBuyables: window.encodeJsonToBase64(JSON.stringify(relatedBuyables)),
            SVGPreviewFront:
                typeof svgs.front != 'undefined' ? window.encodeJsonToBase64(svgs.front) : '',
            SVGPreviewBack:
                typeof svgs.back != 'undefined' ? window.encodeJsonToBase64(svgs.back) : '',
            MarkingCodeFront: markingCode.front,
            MarkingCodeBack: markingCode.back,
            PrintOption: getPrintOptionValue(tagData),
        };

        dispatch(toggleEditorLoading(true));
        dispatch(toggleLoading(true));

        const callback = {
            success: () => {
                if (showRecommendedProducts) {
                    displayRecommendedProducts();
                }

                scrollToTop();
            },
        };

        return axiosUpdateCartItemCustomTag(payload)
            .then(() => {
                dispatch(requestCart());
                dispatch(toggleEditorLoading(false));
                dispatch(toggleLoading(false));

                createAlert(
                    {
                        message: getTranslation(
                            'CART.UPDATE_CART_ITEM.SUCCESS_MESSAGE'
                        ),
                    },
                    'success'
                );
            })
            .catch((error) => {
                handleAxiosErrors(error);
            });
    };
};
/**
 * Add NLIS & Tag Editor Tag item to cart
 *
 * @param passedPayload
 * @returns {Function}
 */
export const addToCartWithJSON = (passedPayload) => {
    return async (dispatch, getState) => {
        let state = getState();
        const tagWizardState = state.tagWizard.present;
        const relatedProducts = getRelatedProducts(tagWizardState);
        const showRecommendedProducts = relatedProducts.length > 0;

        dispatch(toggleEditorLoading(true));
        dispatch(toggleLoading(true));

        const payload = await getPayloadForOfficalTagCartItem(passedPayload, {
            dispatch,
            getState,
        });

        const callback = {
            success: () => {
                if (showRecommendedProducts) {
                    displayRecommendedProducts();
                }

                // Move to UsageScreen
                dispatch(changeScreen('UsageScreen'));

                // Reset tag wizard
                dispatch(resetTagWizard());

                setTimeout(() => {
                    scrollToTop();
                }, 500);
            },
        };

        console.log('debug payload', payload);

        return Promise.all([
            dispatch(
                addToCart(payload, callback, !showRecommendedProducts, '')
            ),
        ]).finally(() => {
            dispatch(toggleEditorLoading(false));
            dispatch(toggleLoading(false));
        });
    };
};

export const updateCartOrderItem = (passedPayload) => {
    return async (dispatch, getState) => {
        dispatch(toggleEditorLoading(true));
        dispatch(toggleLoading(true));

        const payload = await getPayloadForOfficalTagCartItem(passedPayload, {
            dispatch,
            getState,
        });

        return axiosUpdateCartItemCustomTag(payload)
            .then(() => {
                scrollToTop();

                dispatch(requestCart());

                createAlert(
                    {
                        message: getTranslation(
                            'CART.UPDATE_CART_ITEM.SUCCESS_MESSAGE'
                        ),
                    },
                    'success'
                );
            })
            .catch((error) => {
                handleAxiosErrors(error);
            })
            .finally(() => {
                dispatch(toggleEditorLoading(false));
                dispatch(toggleLoading(false));
            });
    };
};

/**
 * Request matching management tags based on code tag family
 *
 * @param ids
 * @returns {function(*=, *): *}
 */
export const requestMatchingManagementTags = (codeTagFamilies) => {
    return (dispatch, getState) => {
        const params = {
            filters: {
                MatchingManagementTag: true,
                CodeTagFamily: codeTagFamilies,
            },
        };

        return axiosRequestProductsForTag(params).then((response) => {
            const list = convertProductsListingToAReadableFormat(
                response.data.data.readProducts
            );
            const listingDisplay = convertDataToListingDisplay(
                response.data.data.readProducts,
                'ID'
            );

            // wait for async requests
            return Promise.all([
                dispatch(updatedMatchingManagementTags(list)),
            ]).then(() => {
                dispatch(requestMatchingManagementTagSellPrice(listingDisplay));
            });
        });
    };
};
export const requestMatchingManagementTagSellPrice = (buyableIDs) => {
    return (dispatch, getState) => {
        return axiosRequestSellPriceByBuyableIDs(buyableIDs).then(
            (response) => {
                const prices = convertProductSalePricesToAReadableFormat(
                    response.data.data.readBuyablePrices
                );

                dispatch(updatedMatchingManagementTags(prices));
            }
        );
    };
};

/**
 * Request male button tags based on the given ids
 *
 * @param ids
 * @returns {function(*=, *): *}
 */
export const requestMaleButtonTags = (ids) => {
    return (dispatch, getState) => {
        return axiosRequestProductsByIDs(ids).then((response) => {
            const list = convertProductsListingToAReadableFormat(
                response.data.data.readProducts
            );
            const listingDisplay = convertDataToListingDisplay(
                response.data.data.readProducts,
                'ID'
            );

            // wait for async requests
            return Promise.all([dispatch(updatedMaleButtonTags(list))]).then(
                () => {
                    dispatch(requestMaleButtonTagSellPrice(listingDisplay));
                }
            );
        });
    };
};
/**
 * Request male button tag sell price based on the given product list
 *
 * @param list
 * @returns {Function}
 */
export const requestMaleButtonTagSellPrice = (buyableIDs) => {
    return (dispatch, getState) => {
        if (buyableIDs.length) {
            return axiosRequestSellPriceByBuyableIDs(buyableIDs).then(
                (response) => {
                    const prices = convertProductSalePricesToAReadableFormat(
                        response.data.data.readBuyablePrices
                    );

                    dispatch(updatedMaleButtonTags(prices));
                }
            );
        }
    };
};

/**
 * Request related tags based on the given ids
 *
 * @param ids
 * @returns {function(*=, *): *}
 */
export const requestRelatedTags = (ids) => {
    return (dispatch, getState) => {
        const store = getState();
        const tagWizardState = store.tagWizard.present;
        const selectedProduct = getSelectedProduct(tagWizardState);

        return axiosRequestProductsByIDs(ids).then((response) => {
            let list = convertProductsListingToAReadableFormat(
                response.data.data.readProducts
            );
            let listingDisplay = convertDataToListingDisplay(
                response.data.data.readProducts,
                'ID'
            );

            // wait for async requests
            return Promise.all([dispatch(updatedRelatedTags(list))])
                .then(() => {
                    dispatch(requestRelatedTagSellPrice(listingDisplay));
                })
                .then(() => {
                    // request included items for NAIT
                    if (selectedProduct?.OfficialType === 'NAIT') {
                        const CodeTagFamily = Object.values(list)[0]
                            ?.CodeTagFamily;

                        return axiosRequestProductsByCodeTagFamily(
                            CodeTagFamily
                        ).then((response) => {
                            list = convertProductsListingToAReadableFormat(
                                response.data.data.readProducts
                            );
                            listingDisplay = convertDataToListingDisplay(
                                response.data.data.readProducts,
                                'ID'
                            );

                            return Promise.all([
                                dispatch(updatedIncludedItemTags(list)),
                            ]).then(() => {
                                // TODO
                                //dispatch(requestRelatedTagSellPrice(listingDisplay));
                            });
                        });
                    }
                });
        });
    };
};

/**
 * Request related tags based on the given ids
 *
 * @param ids
 * @returns {function(*=, *): *}
 */
export const requestIncludedItems = (ids) => {
    return (dispatch, getState) => {
        const store = getState();
        const tagWizardState = store.tagWizard.present;
        const selectedProduct = getSelectedProduct(tagWizardState);

        return axiosRequestProductsByIDs(ids).then((response) => {
            let list = convertProductsListingToAReadableFormat(
                response.data.data.readProducts
            );
            let listingDisplay = convertDataToListingDisplay(
                response.data.data.readProducts,
                'ID'
            );

            // wait for async requests
            return Promise.all([dispatch(updatedRelatedTags(list))])
                .then(() => {
                    dispatch(requestRelatedTagSellPrice(listingDisplay));
                })
                .then(() => {
                    // request included items for NAIT
                    if (selectedProduct?.OfficialType === 'NAIT') {
                        const CodeTagFamily = Object.values(list)[0]
                            ?.CodeTagFamily;
                        console.log('requestRelatedTags NAIT CodeTagFamily');
                        console.log(CodeTagFamily);

                        return axiosRequestProductsByCodeTagFamily(
                            CodeTagFamily
                        ).then((response) => {
                            list = convertProductsListingToAReadableFormat(
                                response.data.data.readProducts
                            );
                            listingDisplay = convertDataToListingDisplay(
                                response.data.data.readProducts,
                                'ID'
                            );

                            console.log('requestRelatedTags list');
                            console.log(list);

                            return Promise.all([
                                dispatch(updatedRelatedTags(list)),
                            ]).then(() => {
                                dispatch(
                                    requestRelatedTagSellPrice(listingDisplay)
                                );
                            });
                        });
                    }
                });
        });
    };
};

export const requestRelatedTagSellPrice = (buyableIDs) => {
    return (dispatch, getState) => {
        return axiosRequestSellPriceByBuyableIDs(buyableIDs).then(
            (response) => {
                const prices = convertProductSalePricesToAReadableFormat(
                    response.data.data.readBuyablePrices
                );

                dispatch(updatedRelatedTags(prices));
            }
        );
    };
};
export const requestRelatedProducts = (ids) => {
    return (dispatch, getState) => {
        if (ids.length == 0) {
            return Promise.resolve({});
        }

        // const LIMIT = 10;
        // const slicedIds = ids.slice(0, LIMIT);
        const slicedIds = ids;

        return axiosRequestProductsByIDs(slicedIds).then((response) => {
            const list = convertProductsListingToAReadableFormat(
                response.data.data.readProducts
            );
            const listingDisplay = convertDataToListingDisplay(
                response.data.data.readProducts,
                'ID'
            );

            // wait for async requests
            return Promise.all([dispatch(updateRelatedProducts(list))]).then(
                () => {
                    dispatch(requestRelatedProductSellPrice(listingDisplay));
                }
            );
        });
    };
};
export const requestRelatedProductSellPrice = (buyableIDs) => {
    return (dispatch, getState) => {
        return axiosRequestSellPriceByBuyableIDs(buyableIDs).then(
            (response) => {
                const prices = convertProductSalePricesToAReadableFormat(
                    response.data.data.readBuyablePrices
                );

                dispatch(updateRelatedProducts(prices));
            }
        );
    };
};
/**
 * Restore the tag wizard state from the given data
 *
 * @param data
 * @returns {Function}
 */
export const restoreTagWizardState = (data) => {
    return (dispatch, getState) => {
        dispatch(setTagWizardData(data));
    };
};

/**
 * Get the exported JSON Data based on the given state
 *
 * @param tagWizardState
 */
export const getTagWizardExportedJSONData = (tagWizardState) => {
    const data = {};

    exportedkeys.forEach((itemKey) => {
        if (typeof tagWizardState[itemKey] != 'undefined') {
            data[itemKey] = tagWizardState[itemKey];
        }
    });

    return data;
};

/**
 * After load, immediately set the default tag usage
 * This function was ported from TagUsage componentDidMount()
 *
 * @returns {Function}
 */
export const setDefaultTagUsage = () => {
    return (dispatch, getState) => {
        const store = getState();

        const availableTagUsage = getAvailableTagUsage(
            store.tagWizard.present,
            store
        );

        const { IsNLIS, CustomTag, BlankTag } = availableTagUsage;

        if (IsNLIS) {
            dispatch(setUserInput('tagType', 'nlis'));
            return;
        }

        if (CustomTag) {
            dispatch(setUserInput('tagType', 'editor'));
            return;
        }

        if (BlankTag) {
            dispatch(setUserInput('tagType', 'blank'));
            return;
        }
    };
};

/**
 * After load, immediately set the default tag usage
 * This function was ported from TagUsage componentDidMount()
 *
 * @returns {Function}
 */
export const setDefaultPrintingMethods = () => {
    return (dispatch, getState) => {
        const store = getState();

        const availablePrintingMethods = getAvailablePrintingMethods(
            store.tagWizard.present
        );

        if (availablePrintingMethods.length > 0) {
            dispatch(
                setUserInput(
                    'printingMethod',
                    availablePrintingMethods[0].value
                )
            );
        }
    };
};

/**
 * After load, immediately set the default tag production types
 * Usually used on NAIT
 *
 * @returns {Function}
 */
export const setDefaultTagProductionTypes = () => {
    return (dispatch, getState) => {
        const store = getState();

        const availableTagProductionTypes = getAvailableTagProductionTypes(
            store.tagWizard.present
        );

        if (availableTagProductionTypes.length > 0) {
            dispatch(
                setUserInput(
                    'tagProductionType',
                    availableTagProductionTypes[0].value
                )
            );
        }
    };
};

/**
 * Run after cart qty change on NAIT
 * Usually used on NAIT
 *
 * @returns {Function}
 */
export const onAfterCartQtyChangeNAIT = () => {
    return (dispatch, getState) => {
        const store = getState();

        let isChanged = false;
        const tagWizardState = store.tagWizard.present;
        const officialType = getTagOfficialType(tagWizardState);

        if (officialType !== 'nait') return;

        const { currentScreen, userInput } = tagWizardState;

        if (currentScreen === 'NAITPropertyScreen') return;

        const { NAITCustomList = [], cartQty = 0 } = userInput;

        // Match NAITCustomList to cartQty
        let values = [...NAITCustomList];

        if (cartQty > values.length) {
            // Add more to the list
            for (let i = values.length; i < cartQty; i++) {
                values.push({ text: '' });
            }

            isChanged = true;
        } else if (cartQty < values.length) {
            values.splice(cartQty, values.length - cartQty);
            isChanged = true;
        }

        if (isChanged) {
            dispatch(setUserInput('NAITCustomList', values));
        }
    };
};

/**
 * Helper function to run axios of request processed layouts
 *
 * @param codeTagFamily
 * @param type
 * @param passedData
 * @param additionalConfig
 * @returns {AxiosPromise<any>}
 */
export const axiosRequestProcessedLayouts = (
    codeTagFamily,
    type,
    passedData = false,
    additionalConfig = {}
) => {
    const {
        NAITVariationTypes = '',
        NAITGroupIdentifier = '',
    } = additionalConfig;

    let { url, query } = config.tags.getLayouts;

    let data = {
        query: query,
        variables: {
            Compile: true,
        },
    };

    if (codeTagFamily) {
        data.variables.CodeTagFamily = codeTagFamily;
    }
    if (type) {
        data.variables.TagType = type;
    }
    if (NAITVariationTypes) {
        data.variables.NAITVariationTypes = NAITVariationTypes;
    }
    if (NAITGroupIdentifier) {
        data.variables.NAITGroupIdentifier = NAITGroupIdentifier;
    }
    if (passedData) {
        let processedData = passedData;

        if (typeof passedData == 'object' || Array.isArray(passedData)) {
            const jsonString = JSON.stringify(passedData);

            processedData = window.encodeJsonToBase64(jsonString)
        }

        data.variables.Data = processedData;
    }

    return axios.post(url, data, {
        withCredentials: true,
    });
};

/**
 * Request the processed layout JSON data from backend (GraphQL)
 *
 * @param codeTagFamily
 * @param type
 * @param diseaseCode
 * @param data
 * @param additionalConfig
 * @returns {function(*=, *): *}
 */
export const requestProcessedLayoutData = (
    codeTagFamily,
    type,
    diseaseCode = '',
    data,
    additionalConfig = {}
) => {
    return (dispatch, getState) => {
        const backendType = getFinalisedTagTypeLayout(type);

        return axiosRequestProcessedLayouts(
            codeTagFamily,
            backendType,
            data,
            additionalConfig
        )
            .then((response) => {
                const layoutData = response.data.data.readTagLayouts;
                if (layoutData != null) {
                    let list = {};

                    layoutData.edges.forEach((item, key) => {
                        const { ID } = item.node;

                        const uniqueKey = generateProcessedLayoutKey(
                            codeTagFamily,
                            type,
                            diseaseCode
                        );

                        if (typeof list[uniqueKey] === 'undefined') {
                            list[uniqueKey] = {};
                        }

                        list[uniqueKey][ID] = item.node;
                    });

                    Object.entries(list).forEach(([key, value]) => {
                        dispatch(setTagWizardAvailableLayouts(key, value));
                    });
                }
            })
            .catch((error) => handleAxiosErrors(error));
    };
};

/**
 * Request all processed layouts from current state (normally for NLIS & NAIT)
 *
 * @returns {function(*, *): function(*=, *): *}
 */
export const requestProcessedLayouts = (type = 'nlis') => {
    return (dispatch, getState) => {
        let store = getState();
        const tagWizardState = store.tagWizard.present;
        const selectedProduct = getSelectedProduct(tagWizardState);
        const codeTagFamily = selectedProduct.CodeTagFamily || '';
        const productID = tagWizardState.selectedProduct;
        const diseaseCode = tagWizardState.userInput.DiseaseCode || '';
        const uniqueKey = generateProcessedLayoutKey(
            codeTagFamily,
            type,
            diseaseCode
        );
        const data = {
            ...tagWizardState.userInput,
            ProductID: productID,
            LastSequenceNumber: tagWizardState.lastSequenceNumber,
            TotalUnitItems: tagWizardState.userInput.cartQty,
        };

        let additionalConfig = {};

        if (type === 'nait') {
            additionalConfig.NAITVariationTypes = getPossibleVariationTypesForNAIT(
                store
            );
        }

        dispatch(toggleLoading(true));

        return Promise.all([
            dispatch(
                requestProcessedLayoutData(
                    codeTagFamily,
                    type,
                    diseaseCode,
                    data,
                    additionalConfig
                )
            ),
        ])
            .then((response) => {
                let store = getState();
                const tagWizardState = store.tagWizard.present;
                const availableProcessedLayouts =
                    tagWizardState.availableProcessedLayouts;

                if (
                    typeof availableProcessedLayouts[uniqueKey] !=
                    'undefined' &&
                    availableProcessedLayouts[uniqueKey]
                ) {
                    const layouts = Object.values(
                        availableProcessedLayouts[uniqueKey]
                    );

                    if (layouts.length) {
                        dispatch(applyTagLayout(layouts[0]));
                    } else {
                        // Show something is wrong
                    }
                }
            })
            .finally(() => {
                dispatch(toggleLoading(false));
            });
    };
};

/**
 * Request all NLIS processed layouts from current state
 *
 * @returns {function(*, *): function(*=, *): *}
 */
export const requestMMTProcessedLayouts = () => {
    return (dispatch, getState) => {
        let store = getState();
        const tagWizardState = store.tagWizard.present;

        const { userInput, selectedMMT = null } = tagWizardState;
        const { IncludeMMT = 0 } = userInput;

        if (IncludeMMT === 0 || selectedMMT === null) {
            return false;
        }

        const selectedProduct = getSelectedMMT(tagWizardState);
        const uniqueKey = generateMMTProcessedLayoutKey(
            tagWizardState,
            selectedProduct
        );

        dispatch(toggleLoading(true));

        return Promise.all([
            dispatch(baseRequestMMTProcessedLayouts(selectedProduct)),
        ])
            .then((response) => {
                let store = getState();
                const tagWizardState = store.tagWizard.present;
                const availableProcessedLayouts =
                    tagWizardState.availableProcessedLayouts;

                if (
                    typeof availableProcessedLayouts[uniqueKey] !=
                    'undefined' &&
                    availableProcessedLayouts[uniqueKey]
                ) {
                    const layouts = Object.values(
                        availableProcessedLayouts[uniqueKey]
                    );

                    if (layouts.length) {
                        dispatch(setMMTTagLayout(layouts[0]));
                    }
                }
            })
            .finally(() => {
                dispatch(toggleLoading(false));
            });
    };
};

export const requestMMTFProcessedLayouts = () => {
    return (dispatch, getState) => {
        let store = getState();
        const tagWizardState = store.tagWizard.present;

        const { userInput, selectedMMTF = null } = tagWizardState;
        const { IncludeMMT = 0 } = userInput;

        if (IncludeMMT === 0 || selectedMMTF === null) {
            return false;
        }

        const selectedProduct = getSelectedMMTF(tagWizardState);
        const uniqueKey = generateMMTProcessedLayoutKey(
            tagWizardState,
            selectedProduct
        );

        dispatch(toggleLoading(true));

        return Promise.all([
            dispatch(baseRequestMMTProcessedLayouts(selectedProduct)),
        ])
            .then((response) => {
                let store = getState();
                const tagWizardState = store.tagWizard.present;
                const availableProcessedLayouts =
                    tagWizardState.availableProcessedLayouts;

                if (
                    typeof availableProcessedLayouts[uniqueKey] !=
                    'undefined' &&
                    availableProcessedLayouts[uniqueKey]
                ) {
                    const layouts = Object.values(
                        availableProcessedLayouts[uniqueKey]
                    );

                    if (layouts.length) {
                        dispatch(setMMTFTagLayout(layouts[0]));
                    }
                }
            })
            .finally(() => {
                dispatch(toggleLoading(false));
            });
    };
};

/**
 * Requester for MMT & MMTF Processed Layout
 *
 * @param selectedProduct
 * @returns {function(*, *): Promise<unknown[]>}
 */
export const baseRequestMMTProcessedLayouts = (selectedProduct) => {
    return (dispatch, getState) => {
        let store = getState();
        const tagWizardState = store.tagWizard.present;

        const { userInput } = tagWizardState;
        const { cartQty = 1 } = userInput;

        const tagOfficialType = getTagOfficialType(tagWizardState);

        const selectedOfficalTagLayout = getSelectedOfficialTagLayoutData(
            tagWizardState
        );
        const codeTagFamily = selectedProduct.CodeTagFamily || '';
        const productID = selectedProduct.ID;
        const diseaseCode = '';
        const type = tagOfficialType === 'nait' ? 'nait-mmt' : 'mmt';

        const additionalConfig = {
            NAITGroupIdentifier:
                selectedOfficalTagLayout?.NAITGroupIdentifier || '',
        };

        const data = {
            ...tagWizardState.userInput,
            ProductID: productID,
            LastSequenceNumber: tagWizardState.lastSequenceNumber,
            TotalUnitItems: cartQty,
        };

        return Promise.all([
            dispatch(
                requestProcessedLayoutData(
                    codeTagFamily,
                    type,
                    diseaseCode,
                    data,
                    additionalConfig
                )
            ),
        ]);
    };
};

export const applyTagLayout = (tagLayout) => {
    return (dispatch) => {
        const { EncodedJSONData, ID } = tagLayout;
        let decodedJSONData = window.decodeJsonFromBase64(EncodedJSONData);

        if (typeof decodedJSONData == 'string') {
            decodedJSONData = JSON.parse(decodedJSONData);
        }

        return Promise.all([
            dispatch(resetCanvases()),
            dispatch(setUserInput('selectedLayoutVariationID', ID)),
            dispatch(setUserInput('CustomFieldNumber', '')),
            dispatch(
                setTagData(decodedJSONData, [
                    'cartQty',
                    'sku',
                    'group',
                    'activeColour',
                ])
            ),
        ]).then(() => {
            dispatch(setupCanvases());
        });
    };
};

export const requestLineItemProducts = (IDs = []) => {
    return (dispatch, getState) => {
        let finalListParams = {
            filters: {
                LineItem: true,
            },
        };

        if (IDs && IDs.length > 0) {
            finalListParams.filters.IDs = IDs;
        }

        // Normal axios request
        return axiosRequestProductsForTag(finalListParams)
            .then((response) => {
                const list = convertProductsListingToAReadableFormat(
                    response.data.data.readProducts
                );
                const listingDisplay = convertDataToListingDisplay(
                    response.data.data.readProducts,
                    'ID'
                );

                // wait for async requests
                return Promise.all([
                    dispatch(updateProductList(list)),
                    dispatch(updateLineItemsProductList(listingDisplay)),
                ]).then(() => {
                    if (listingDisplay && listingDisplay.length) {
                        return dispatch(requestPrice(listingDisplay));
                    }
                });
            })
            .catch((error) => {
                dispatch(updateHasInitialized(true));
                dispatch(toggleLoading(false));
                handleAxiosErrors(error);
            });
    };
};

/**
 * Validate NAIT Sequence
 *
 * @returns {function(*=, *): Promise<unknown[]>}
 */
export const validateNAITSequence = () => {
    return (dispatch, getState) => {
        const tagWizardState = getState().tagWizard.present;
        const product = getSelectedProduct(tagWizardState);
        const { Replacement = false } = product;
        const { UseDuplicate = 0 } = tagWizardState.userInput;

        // Replacement Tag does not need any validation
        if (Replacement === true) {
            return Promise.resolve({
                status: true,
            });
        }

        // Set loading
        dispatch(toggleLoading(true));

        // And create params for the request
        let params = buildValidateNAITSequenceParams(getState());

        // Normal axios request
        return axiosValidateNAITSequence(params)
            .then((response) => {
                const errorRecords = JSON.parse(
                    response.data.data.validateTagSequenceMutation.ErrorRecords
                );

                // Set error
                dispatch(
                    setTagWizardError(
                        `NAITSequence-${UseDuplicate}`,
                        errorRecords
                    )
                );

                if (!Object.entries(errorRecords).length) {
                    return {
                        status: true,
                    };
                } else {
                    return {
                        status: false,
                    };
                }
            })
            .catch((error) => {
                dispatch(updateHasInitialized(true));
                handleAxiosErrors(error);

                return {
                    status: false,
                };
            })
            .then((response) => {
                dispatch(toggleLoading(false));

                return response;
            });
    };
};

export const axiosRequestProductsForTag = (params) => {
    let { url, query } = config.product.tagWizardVariations;

    if (isInGodMode()) {
        // This force the hidden product to be displayed
        params.filters.MatchingManagementTag = true;
    }

    query = query.replace(/{params}/, buildRequestProductsParams(params));

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};

/**
 * Axios to validate NAIT Sequence
 *
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const axiosValidateNAITSequence = (params) => {
    let { url, query } = config.tags.validateNAITSequence;

    let data = {
        query: query,
        variables: {
            ...params,
        },
    };

    return axios.post(url, data, {
        withCredentials: true,
    });
};

/**
 * Helper function to create params to validate NAIT Sequence
 *
 * @param store
 * @returns {{VariationType: *}}
 */
export const buildValidateNAITSequenceParams = (store) => {
    const tagWizardState = store.tagWizard.present;
    const {
        UseDuplicate = 0,
        NAITNumber,
        NAITCustomList,
        Year,
        UseCustomList,
        ParticipantCode,
        StartingNumber,
        cartQty,
    } = tagWizardState.userInput;

    const selectedLayout = getSelectedOfficialTagLayoutData(tagWizardState);

    if (!selectedLayout || !selectedLayout?.NAITVariationType) {
        throw new Error('Invalid Tag Layout');
    }

    let params = {
        NaitNumber: NAITNumber,
        VariationType: selectedLayout.NAITVariationType,
    };

    // If it's an edit cart
    if (window.cartItemID !== undefined && window.cartItemID) {
        params.BuyableDataIDs = [Number(window.cartItemID)];
    }

    // Do the series
    let seriesParams = {};
    if (UseCustomList == 1) {
        seriesParams.SequenceList = NAITCustomList.map((item) => item.text);
    } else {
        seriesParams = {
            StartingNumber,
            ItemQuantity: cartQty,
        };
    }

    // If it's a duplicate tag
    if (UseDuplicate == 1) {
        params = {
            ...params,
            DuplicateTag: true,
        };
    }

    // Create payload
    switch (params.VariationType) {
        case 'NAITNUM-YR-SERIES':
            // NaitNumber has been sent in earlier payload preparation
            params = {
                ...params,
                ...seriesParams,
                Year: Number(Year),
            };

            break;

        case 'NAITNUM-SERIES':
            // NaitNumber has been sent in earlier payload preparation
            params = {
                ...params,
                ...seriesParams,
            };

            break;

        case 'PATCODE-YR-SERIES':
            params = {
                ...params,
                ...seriesParams,
                ParticipantCode: ParticipantCode,
                Year: Number(Year),
            };

            break;
    }

    return params;
};
